































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItemTypes from '../components/NewsItem.vue';
import { getNewsTwo } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItemTypes,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  isShow: boolean = true;
  typesList = [
    { id: 1, name: '新闻', showname: '新闻' },
    { id: 2, name: '专访', showname: '专访' },
    { id: 3, name: '视频', showname: '视频' },
    { id: 4, name: '图片', showname: '图片' },
  ];
  activeId: number = 1;

  goDetail(a: any) {
    if (window.udid && a.dataType !== 7 && a.dataType !== 5) {
      const msg = {
      action: 'mJump',
      data: JSON.stringify({
        dt: a.dataType,
        cid: a.classId || a.columnId,
        nid: a.id,
        url: a.targetUrl,
        title: a.title || a.navTitle,
        })
      };
      window.handleMessage(JSON.stringify(msg));
    } else {
      location.href = a.targetUrl;
    }
  }
  onLoad() {
    getNewsTwo(this.page, this.typesList[this.activeId - 1].name, '10130').then(
      // getNewsTwo(this.page, '全部', '1').then(
      (res: any) => {
        this.endListData(res);
      },
    );
  }
  changeorder(teamid: number) {
    this.loading = false;
    this.page = 1;
    this.list = [];
    this.finished = false;
    this.activeId = teamid;
    this.isShow = false;
      setTimeout(() => {
        this.isShow = true;
      },50)
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode === 404) {
      this.finished = true;
    } else {
      if (!res.data.data || res.data.data.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.data[0].list];
        }
      }
    }
    this.loading = false;
  }
}
